import React, { ChangeEvent, useState } from 'react'
import { ApiUrl } from '../../config/apiConfig';
import { uploadpdf } from '../../services/Axios/Axios';
import messageService from '../../services/message/messageService';
import downloadIcon from "../../assets/img/downlod.svg";
import Swal from "sweetalert2";
interface UploadResponse {
    success: boolean;
    message: string;
  }
  
  const CsvFileShippers= ({getDataALLs2}:any) => {
    const [file, setFile] = useState<File | null>(null);
    const [message, setMessage] = useState<string | null>(null);
  
    const handleFileChange = async (event: ChangeEvent<HTMLInputElement>) => {
 
      if (event.target.files && event.target.files[0]) {
        const selectedFile = event.target.files[0];
        setFile(selectedFile);


        const validFileTypes = [
          "text/csv",
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        ];
  
        if (
    
          validFileTypes.includes(selectedFile.type) ||
          selectedFile.name.endsWith(".csv") ||
          selectedFile.name.endsWith(".xlsx")
        ) 
  
          
          
          {
            try {
              const response = await uploadpdf(ApiUrl.shipperRecieverCsvUpload, selectedFile);
              console.log("Upload Response:", response);
            
              const messageServicesd = messageService();
              messageServicesd.toast("success", response.message);
              getDataALLs2();
            
              if (response.success) {
                setFile(null);
                messageServicesd.toast("success", response.message);
              } else {
                setMessage("Upload failed: " + response.message);
              }
            
            } catch (error: any) {
              console.error("Error uploading file:", error);
            
              if (error?.response?.data?.message) {
                setMessage("Upload failed: " + error.response.data.message);
              } else {
                setMessage("An error occurred during upload");
              }
            }
            
        } else {
          const messageServicesd = messageService();
          messageServicesd.toast(
            "error",
            "Unsupported file type. Please upload a CSV or XLSX file."
          );
        }
      }
    };
  
   
    const triggerFileInput = () => {
      Swal.fire({
        title: 'Upload Confirmation',
        text: "You can upload CSV and XLSX files up to 5000 records.",
        icon: 'info',
        showCancelButton: true,
        confirmButtonText: 'Upload',
        cancelButtonText: 'Cancel',
      }).then((result) => {
        if (result.isConfirmed) {
          const fileInput = document.getElementById("file-input") as HTMLInputElement;
          if (fileInput) {
            fileInput.click();
          }
        }
      });
    };


    return (
      <div className="rotate h-fit w-[7rem] relative flex items-center">
        <input
          id="file-input"
          type="file"
          // accept=".csv"
          className="absolute top-1"
         accept=".csv, .xlsx"
          style={{ display: 'none' }}
          onChange={handleFileChange}
        />
        <img
          src={downloadIcon}
          alt="Download Icon"
          onClick={triggerFileInput}
          style={{ cursor: 'pointer' }}
        />
        {/* {message && <div>{message}</div>} */}
      </div>
    );
  };
  
export default CsvFileShippers
